import { render, staticRenderFns } from "./popup-folder-options.vue?vue&type=template&id=19616660&"
import script from "./popup-folder-options.vue?vue&type=script&lang=js&"
export * from "./popup-folder-options.vue?vue&type=script&lang=js&"
import style0 from "./popup-folder-options.vue?vue&type=style&index=0&id=19616660&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports